// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/transition.css
// module id = 9R5P
// module chunks = 42